import React from 'react';
import PropTypes from 'prop-types';

const Buttons = props => (
  <section className="module-filter top">
    <div className="general-help"><div>
      {props.language.summary.behaviour.generalHelp}
    </div></div>
    <div className="flex">
      <div className="title left">
        {props.language.detail_behavior.title.ranking}
      </div>
      <div className="excel-buttons">
        <div className="box-form">
          <ul className="buttom_menu">
            <li>
              {props.language.summary.behaviour.downloadExcel}
              <ul>
                <li>
                  <a data-close="ok" onClick={props.handleDownloadExcelSummary}>
                    {props.language.summary.behaviour.downloadSummaryExcel}
                  </a>
                </li>
                <li>
                  <a data-close="ok" onClick={props.handleDownloadExcelNoProcess}>
                    {props.language.summary.behaviour.downloadNoProcessExcel}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/detail_behavior/buttons.jsx